module.exports = __webpack_public_path__ + "img/zwsj@3x.6303cb5e.png";